import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import {
  LoginReducer,
  OTPVerificationReducer,
  UserDetailReducer,
} from "../slice";
import { useCallback } from "react";

function OTPVerification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const OTPverify = localStorage.getItem("OTPverify");
  const countryCode = localStorage.getItem("countryCode");
  const mobile = localStorage.getItem("mobile");

  const [seconds, setSeconds] = useState(30);
  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    }
  }, [seconds]);

  const resendCode = () => {
    dispatch(
      LoginReducer({
        countryCode: countryCode,
        phoneNumber: mobile,
        deviceType: "W",
      })
    ).then(async (data) => {
      if (data?.payload?.code === 3) {
        toast.success(data?.payload?.message);
        await localStorage.setItem("token", data?.payload?.data?.authToken);
      } else {
        toast.error(data?.payload?.message);
      }
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getUserDetail = useCallback(() => {
    dispatch(UserDetailReducer({}));
  }, [dispatch]);

  return (
    <>
      <section className="bg-image">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-5 col-lg-6">
              <div className="my-4">
                <img
                  src="assets/images/logo.png"
                  className="img-fluid logo-admin"
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="row align-items-center UserLoginImg">
            <div className="col-sm-12 col-md-12 col-lg-6 text-center">
              <img src="assets/images/otp.png" alt="" className="w-50" />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="form-bg">
                <Formik
                  initialValues={{
                    otp: "",
                  }}
                  validationSchema={Yup.object({
                    otp: Yup.string()
                      .required("Required")
                      .matches(/^[0-9]+$/, "Must be only digits")
                      .min(6, "Kindly enter valid otp.")
                      .max(6, "Kindly enter valid otp."),
                  })}
                  onSubmit={(values, action) => {
                    setLoading(true);

                    dispatch(
                      OTPVerificationReducer({
                        otp: values.otp,
                      })
                    ).then(async (data) => {
                      setLoading(false);
                      if (data?.payload?.code === 1) {
                        toast.success(data?.payload?.message);
                        await localStorage.removeItem("countryCode");
                        await localStorage.removeItem("mobile");
                        await localStorage.setItem(
                          "houzezToken",
                          data?.payload?.data?.authToken
                        );
                        getUserDetail();
                        navigate("/plan", {
                          replace: true,
                        });
                      } else {
                        setLoading(false);
                        toast.error(data?.payload?.message);
                      }
                    });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFormikState,
                    setFieldValue,
                  }) => (
                    <form
                      className="form-style"
                      onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleSubmit();
                      }}
                    >
                      <div className="row mt-5">
                        <div className="col-sm-12 col-md-12 mb-2">
                          <h2 className="mdl-ttl">OTP Verification</h2>
                          <p className="mdl-sbttl">
                            Please enter 6 digit code, which has been sent on
                            your registered Mobile No.
                          </p>
                        </div>
                        <div className="col-sm-12 col-md-12 mb-4">
                          <div className="form-group">
                            <div className="input-container">
                              <OtpInput
                                containerStyle="passcode-wrapper"
                                value={values.otp}
                                onChange={(val) => {
                                  setFieldValue("otp", val);
                                }}
                                inputStyle={"otpInputs"}
                                numInputs={6}
                                separator={<span> </span>}
                                keyboardType={"numeric"}
                                shouldAutoFocus={true}
                              />
                            </div>
                          </div>
                          {errors.otp && touched.otp && (
                            <div className="text-red">{errors.otp}</div>
                          )}
                        </div>
                        <div className="form-group col-sm-12 col-md-12 text-center mb-3">
                          <p className="otp-timing">
                            <p className="mb-0">
                              <img src="assets/images/Clock.png" alt="" />
                            </p>

                            <span>
                              00:{seconds > 9 ? seconds : `0${seconds}`}{" "}
                            </span>
                          </p>
                        </div>
                        <div className="col-sm-12 col-md-12 text-center mb-3">
                          <button type="submit" className="btn btn-save w-100">
                            {loading ? <Loader /> : "Verify"}
                          </button>
                        </div>
                        <div className="form-group col-sm-12 col-md-12 text-center mb-4">
                          <span
                            className={
                              seconds === 0
                                ? "forgot-pass cursor-pointer p-0"
                                : "forgot-pass d-none p-0"
                            }
                            onClick={() => {
                              resendCode();
                              setSeconds(30);
                            }}
                          >
                            Resend Code
                          </span>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OTPVerification;
